import { Card, HStack, RootThemeProvider } from '@direct-frontend/components';
import { PageStub } from '#shared/components/PageStub';
import { useTheme } from '#shared/lib/theme';
import { DashboardSidebarStub } from '../components/DashboardLayout/DashboardSidebarStub';
import styles from './ApplicationStub.module.css';

export const ApplicationStub = () => {
    const theme = useTheme();

    return (
        <RootThemeProvider theme={theme}>
            <HStack>
                <DashboardSidebarStub />
                <Card className={styles.card} padding="16">
                    <PageStub className={styles.pageStub} />
                </Card>
            </HStack>
        </RootThemeProvider>
    );
};
